<template>
<div class="whiteList">
  <el-breadcrumb separator="/">
    <el-breadcrumb-item>
      <span class="page-title" @click="closeWhiteList">盲盒管理</span>
    </el-breadcrumb-item>
    <el-breadcrumb-item>白名单</el-breadcrumb-item>
  </el-breadcrumb>
  <div class="page-actions" style="margin-top: 10px">
    <div class="op">
      <el-select v-model="searchInfo.type" @change="changeType">
        <el-option v-for="item in searchSelects" :key="item.value" :label="item.name" :value="item.value">{{item.name}}</el-option>
      </el-select>
      <el-input v-model="searchInfo.userKey" placeholder="请输入" clearable></el-input>
      <el-button type="primary" @click="addWhiteList">加入白名单</el-button>
      <span>白名单盒子剩余数：{{residueBox || 0}}</span>
    </div>
    <div class="tips">
      <p>1、开启盲盒白名单请在活动开始之前进行设置，白名单用户可免费开启盲盒</p>
      <p>2、设置白名单：先把用户加入白名单，分配盒子数默认为1，可再进行数量分配，白名单用户不得超过白名单盒子数</p>
    </div>
  </div>
  <el-card class="page-content">
    <el-table :data="dataList" border style="width: 100%" size="small">
      <el-table-column label="盲盒名称">
        <template slot-scope="scope">
          {{JSON.parse(scope.row.blindBoxName)['zh']}}
        </template>
      </el-table-column>
      <el-table-column label="序号" type="index" width="80" />
      <el-table-column label="用户ID" prop="userId" />
      <el-table-column label="手机号" prop="tel" />
      <el-table-column label="邮箱" prop="email" />
      <el-table-column label="分配盒子数" prop="distributionNum" />
      <el-table-column label="已开盒子数" prop="openNum" />
      <el-table-column label="支付(币种、数量)" min-width="120">
        <template slot-scope="scope">
          <span v-if="!scope.row.payInfo">0</span>
          <span v-else>
            <span class="payInfo" v-for="(item, index) in JSON.parse(scope.row.payInfo)" :key="index">{{item.coinType}}: {{item.num}}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="240">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="editBox(scope.row)">编辑</el-button>
          <el-button type="danger" size="small" :disabled="scope.row.openNum !== 0" @click="deleteItem(scope.row)">删除</el-button>
          <el-button type="primary" size="small" @click="openDialog(scope.row)">支付设置</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
  <el-dialog title="支付设置" :visible.sync="dialogVisible" width="500px">
    <el-form :model="formData" size="small" label-width="90px">
      <el-form-item label="支付币种" required>
        <div class="pay-content" v-for="(item, index) in formData.pays" :key="index">
          <el-autocomplete
              class="input-number"
              v-model="item.coinType"
              :fetch-suggestions="querySearch"
              placeholder="请输入币种"
              size="small"
          >
            <i
                class="el-icon-close el-input__icon"
                slot="suffix"
                @click="cleanSearchCoin(index)"
                style="cursor: pointer"
            ></i>
          </el-autocomplete>
          <el-input v-model="item.num" :max-length="50" clearable placeholder="请输入数量" size="small"></el-input>
          <el-button type="danger" @click="delItem(index)" size="small"><i class="el-icon-minus"></i></el-button>
        </div>
        <el-button type="primary" @click="addItem" size="small"><i class="el-icon-plus"></i></el-button>
      </el-form-item>
    </el-form>
    <div class="footer" slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="submitForm">确定</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {mapState} from "vuex";
import api from './api'
export default {
  name: "whiteList",
  data() {
    return {
      searchSelects: [
        { name: '用户ID', value: 1 },
        { name: '手机号', value: 2 },
        { name: '邮箱', value: 3 },
      ],
      searchInfo: {
        type: 1
      },
      dataList: [],
      dialogVisible: false,
      formData: {
        pays: []
      },
      residueBox: 0,
      selectRow: {}
    }
  },
  computed: {
    ...mapState('newMagicBox', ['selectData', 'allCoins'])
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const { data } = await api.getWhiteList({blindBoxId: this.selectData.id})
      this.dataList = data
      this.residueBox = this.selectData.whiteBlindBoxTotal;
      this.dataList.forEach(item => {
        this.residueBox -= item.distributionNum
      })
    },
    changeType() {
      this.searchInfo.userKey = ''
    },
    closeWhiteList() {
      this.$store.commit('newMagicBox/setShowWhiteList', false)
    },
    addWhiteList() {
      if (!this.searchInfo.userKey) {
        return this.$message({ message: '请输入需求添加的账户', type: 'warning' })
      }
      if (this.residueBox === 0) {
        return this.$message({ message: '暂无可分配的盒子，无法添加用户', type: 'warning' })
      }
      api.addWhiteList({
        blindBoxId: this.selectData.id,
        ...this.searchInfo
      }).then(res => {
        if (res.code === 0) {
          this.getList()
          this.$message({
            type: 'success',
            message: '添加成功'
          });
        }
      })
    },
    // 删除
    deleteItem(row) {
      this.$confirm('确定删除白名单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delWhiteList({
          id: row.id
        }).then( res => {
          if (res.code === 0) {
            this.getList()
            this.$message({
              type: 'success',
              message: '已删除!'
            });
          }
        })

      }).catch(() => {

      });
    },
    openDialog(row) {
      this.formData.id = row.id
      this.formData.pays = row.payInfo ? JSON.parse(row.payInfo) : []
      this.dialogVisible = true;
    },
    querySearch(queryString, cb) {
      var results = [];
      var coinList = this.allCoins;
      results = queryString
          ? coinList.filter(this.createFilter(queryString))
          : coinList;
      results = results.map((v, i, arr) => {
        return {
          value: v
        };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      let tempData = this.coinTypes;
      return tempData => {
        return tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    cleanSearchCoin(index) {
      this.$set(this.formData.pays[index], 'coinType', '')
    },
    addItem() {
      this.formData.pays.push({ coinType: '', num: undefined })
    },
    delItem(index) {
      this.formData.pays.splice(index, 1)
    },
    submitForm() {
      if (!this.formData.pays.every(item => item.coinType && item.num)) {
        return this.$message({ message: '请将支付配置填写完整', type: 'warning' })
      }
      if (this.formData.pays.some(item => !/^([1-9]\d*)(\.\d{1,50})?$|^0\.\d{1,50}?$/.test(item.num))) {
        return this.$message({ message: '支付数量必须为数字并且大于0', type: 'warning' })
      }
      const sendData = this.formData.pays.length === 0 ? { id: this.formData.id, payInfo: '' } : { id: this.formData.id, payInfo: JSON.stringify(this.formData.pays) }
      api.setPay(sendData).then(res => {
        if (res.code === 0)  {
          this.getList()
          this.dialogVisible = false
        }
      })
    },
    // 编辑盒子数
    editBox(row) {
      this.selectRow = row
      this.$prompt(`请输入分配盒子数(剩余盒子数:${this.residueBox})`, '编辑', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.distributionNum,
        inputPlaceholder: '请输入分配盒子数',
        inputValidator: this.validBox
      }).then(({ value }) => {
        api.addBox({
          id: row.id,
          distributionNum: Number(value)
        }).then( res => {
          if (res.code === 0) {
            this.getList()
            this.$message({
              type: 'success',
              message: '分配成功'
            });
          }
        })

      }).catch(() => {

      });
    },
    validBox(value) {
      if (!/^[1-9]\d*$/.test(value) || Number(value) - Number(this.selectRow.distributionNum) > this.residueBox) {
        return '分配盒子数只能为正整数并且在原有基础上新增的盒子数不能大于剩余盒子数'
      }
      return true
    }
  }
}
</script>

<style scoped lang="less">
.page-title {
  cursor: pointer;
}
.page-actions {
  .op {
    > * {
      margin-right: 10px;
    }
    width: 100%;
    .el-input {
      width: 300px;
    }
  }
  .tips {
    width: 100%;
    padding-left: 32px;
    background: url("../../assets/images/tip.png") no-repeat;
    background-size: 24px;
    background-position: left top;
    p {
      width: 100%;
      margin: 0;
    }
  }
}
.whiteList {
  ::v-deep.el-form-item {
    .el-autocomplete, .el-input {
      width: 150px;
      margin-right: 10px;
    }
    .pay-content {
      margin-bottom: 10px;
    }
  }
  .payInfo {
    padding-right: 10px;
    position: relative;
    &::after {
      content: ';';
      position: absolute;
    }
    &:nth-last-of-type(1) {
      &::after {
        display: none;
      }
    }
  }
}
</style>